module.exports = __webpack_public_path__ + "img/Feature.cb697f8b.png";